try {
    window.$ = window.jQuery = require("jquery");
    require("slick-carousel");
    require("@fancyapps/fancybox/dist/jquery.fancybox.js");
} catch (e) {
}

$(document).ready(function () {
    $("#slideshow").slick({
        slidesToShow: 1,
        dots: true,
        infinite: true,
        arrows: false,
    });

    $("[data-bg]").each(function () {
        var src = $(this).data("bg");
        $(this).css("background-image", "url(" + src + ")");
    });

    $(".file-input").on("click", function () {
        $('input[type="file"]#image')[0].click();
    });

    $('input[type="file"]#image').change(function () {
        var fileName = $(this).val();
        $(".file-input span").html(fileName);
    });

    $(".contact-bottom-form, .contact-form-quick").submit(function (e) {
        e.preventDefault();
        var submitButton = $('button[type="submit"]');
        submitButton.attr("disabled", true);

        formData = new FormData(this);
        for (var pair of formData.entries()) {
            console.log(pair[0] + ", " + pair[1]);
        }

        $.ajax({
            type: "POST",
            url: "/contact.php",
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function (data) {
                window.location.href = '/aplicare-cu-succes'
                $(".contact-bottom-form, .contact-form-quick").hide();
                $(".contact-form-bottom-success").addClass("show");
                $('input[type="text"]').val("");
                $('input[type="file"]').val("");
                $("textarea").val("");
                $(".file-input span").html(
                    '<i class="fas fa-camera"></i> Incarca o poza'
                );
                submitButton.attr("disabled", false);
                setTimeout(function () {
                    $(".contact-form-bottom-success").removeClass("show");
                    $(".contact-bottom-form, .contact-form-quick").show();
                }, 3000);
            },
            error: function (response) {
                var data = JSON.parse(response.responseText);
                $.each(data.errors, function (field, messages) {
                    $(".form-error-" + field)
                        .addClass("show")
                        .text(messages[0]);
                });
                submitButton.attr("disabled", false);
            },
        });
    });

    $(".contact-bottom-form input, .contact-form-quick input").keydown(
        function () {
            var field = $(this).attr("name");
            $(".form-error-" + field)
                .removeClass("show")
                .text("");
        }
    );

    $(".fancybox").fancybox({
        youtube: {
            autoplay: true,
        },
    });

    $(".contact-bottom-form").on("change", "#mini_interviu_checkbox", function () {
        if (this.checked) {
            $("#mini-interviu").show();
        } else {
            $("#mini-interviu").hide();
            $('input[type="radio"]').val(null);
        }
    });
});
